import React from "react";
import styles from "./youtube.css";

export const youtubeVideo = RegExp("(youtube.com/watch)", "gi");
// eslint-disable-next-line
export const youtubeVideoId = RegExp("[^\v=]*$", "gi");

export const YoutubePlayer = ({ id }) => {
	return (
		<div className={styles.videoWrapper}>
			<iframe
				title="youtube"
				width="560"
				height="315"
				src={`https://www.youtube-nocookie.com/embed/${id}?rel=0&amp;showinfo=0&amp;`}
				frameborder="0"
				allow="autoplay; encrypted-media"
				allowfullscreen
			/>
		</div>
	);
};



// WEBPACK FOOTER //
// ./src/components/providers/youtube/youtube.js